import React, { useState, useEffect } from "react"
import { Col, Row } from "reactstrap"
import { connect } from "react-redux"
import Select from "react-select"
import { editAttendee, editAttendeeAndRsvp, updateRsvp } from "store/actions"
import { SaveButton } from "components/Buttons"

const EditInviteModal = ({
  selectedAttendee,
  onClose,
  editAttendee,
  editAttendeeAndRsvp,
  updateRsvp,
  selectedEvent,
  vendorId,
  eventInviteListSortOptions,
}) => {
  const [rsvpWasUpdated, setRsvpWasUpdated] = useState(false)
  const [inputValues, setInputValues] = useState({})

  useEffect(() => {
    setInputValues(selectedAttendee)
  }, [selectedAttendee])

  const rsvpSelectOptions = [
    { value: 3, label: "No Reply" },
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
    { value: 2, label: "Maybe" },
  ]

  const editAttendeeSubmitHandler = (rsvpWasUpdated, inputValues) => {
    if (selectedAttendee.rsvp_string_type === "Meta Tag") {
      if (rsvpWasUpdated) {
        updateRsvp(
          selectedEvent.id,
          vendorId,
          {
            id: inputValues.rsvp_id,
            invite_id: null,
            status: inputValues.rsvp_status,
            total_participants: inputValues.total_participants,
          },
          eventInviteListSortOptions
        )
        onClose()
        return
      }
    }
    if (rsvpWasUpdated) {
      editAttendeeAndRsvp(
        selectedEvent.id,
        {
          id: inputValues.rsvp_id,
          invite_id: inputValues.invite_id,
          status: inputValues.rsvp_status,
          total_participants: inputValues.total_participants,
        },
        inputValues
      )
    } else {
      editAttendee(inputValues)
    }
    onClose()
  }

  return (
    <React.Fragment>
      {selectedAttendee?.rsvp_string_type === "Email Invite" && (
        <div>
          <Row className="mb-2">
            <div>
              {<label>First name</label>}
              <div>
                <input
                  placeholder="First name"
                  type="text"
                  className="form-control"
                  value={inputValues?.first_name || ""}
                  onChange={event => {
                    setInputValues({
                      ...inputValues,
                      first_name: event.target.value,
                    })
                  }}
                />
              </div>
            </div>
          </Row>
          <Row className="my-2">
            <div>
              {<label>Last name</label>}
              <div>
                <input
                  placeholder="Last name"
                  type="text"
                  className="form-control"
                  value={inputValues?.last_name || ""}
                  onChange={event => {
                    setInputValues({
                      ...inputValues,
                      last_name: event.target.value,
                    })
                  }}
                />
              </div>
            </div>
          </Row>
          <Row className="my-2">
            <div>
              {<label>Email</label>}
              <div>
                <input
                  placeholder="Email"
                  type="text"
                  disabled={true}
                  className="form-control"
                  value={inputValues?.email}
                  onChange={event => {
                    setInputValues({
                      ...inputValues,
                      email: event.target.value,
                    })
                  }}
                />
              </div>
            </div>
          </Row>
        </div>
      )}
      {inputValues?.user_status === "Active" ? (
        <Row className="mb-2">
          <div>
            {<label>Select your RSVP status</label>}
            <div>
              <Select
                onChange={selected => {
                  setInputValues({
                    ...inputValues,
                    rsvp_status: selected.value,
                  })
                  setRsvpWasUpdated(true)
                }}
                value={rsvpSelectOptions.filter(
                  option => option.value === inputValues.rsvp_status
                )}
                classNamePrefix="select2-selection"
                options={rsvpSelectOptions}
              />
            </div>
          </div>
        </Row>
      ) : (
        <Row className="mb-4">
          <Col>
            The user's account is not active yet. You are not allowed to edit
            his RSVP.
          </Col>
        </Row>
      )}
      {(inputValues?.rsvp_status === 0 ||
        inputValues?.rsvp_status === 1 ||
        inputValues?.rsvp_status === 2) && (
        <Row className="mb-2">
          <div>
            {<label>Total Attendees Coming (including you)</label>}
            <div>
              <input
                required={true}
                disabled={inputValues?.rsvp_status === 0}
                placeholder="Total Attendees Coming (including you)"
                type="number"
                className="form-control"
                value={
                  inputValues?.rsvp_status === 0
                    ? 0
                    : inputValues.total_participants
                }
                onChange={event => {
                  setInputValues({
                    ...inputValues,
                    total_participants: event.target.value,
                  })
                  setRsvpWasUpdated(true)
                }}
              />
            </div>
          </div>
        </Row>
      )}
      <Row className="mt-3">
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Cancel"
            onClick={onClose}
          />
        </Col>
        {inputValues?.user_status === "Pending" &&
        inputValues.rsvp_string_type === "Meta Tag" ? (
          <></>
        ) : (
          <Col>
            <SaveButton
              content="Update"
              fullWidth={true}
              type="button"
              onClick={() => {
                editAttendeeSubmitHandler(rsvpWasUpdated, inputValues)
                setRsvpWasUpdated(false)
              }}
            />
          </Col>
        )}
      </Row>
    </React.Fragment>
  )
}
const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  selectedEvent: state.experiences.selectedEvent,
  eventInviteListSortOptions: state.experiences.eventInviteListSortOptions,
})

const mapDispatchToProps = dispacth => ({
  editAttendeeAndRsvp: (eventId, rsvp, attendee) =>
    dispacth(editAttendeeAndRsvp(eventId, rsvp, attendee)),
  editAttendee: values => dispacth(editAttendee(values)),
  updateRsvp: (eventId, vendorId, rsvp, eventInviteListSortOptions) =>
    dispacth(updateRsvp(eventId, vendorId, rsvp, eventInviteListSortOptions)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditInviteModal)
